// Function to update price based on badge title
export const updatePrice = (product) => {
  const isNew = product?.badgeTitle?.toLowerCase() === 'new';
  const Price =
    !isNew && product?.badgeTitle?.includes('%')
      ? (product?.price * (1 - parseFloat(product?.badgeTitle) / 100)).toFixed(
          2
        )
      : product?.price;

  return parseFloat(Price);
};

// Function to calculate total amount for cart slice
export const calculateTotalAmount = (items) => {
  const total = items.reduce(
    (sum, item) => sum + Math.round(updatePrice(item)) * item.quantity,
    0
  );

  return total;
};
